import * as React from 'react';
import ReactDOM from 'react-dom';
import { Panel, PanelBody, PanelHeader, CloseButton } from 'components';

import './style.scss';
import { IPanelProps } from 'components/panel';
import clsx from 'clsx';
import { WithTranslation, withTranslation } from 'react-i18next';
import { OverlayFormInput } from 'components/overlay';

export interface ILinkWindowProps extends IPanelProps, WithTranslation {
    link: string;
    onClose: () => any;
}
export interface ILinkWindowState {}

class LinkWindowComponent extends React.Component<ILinkWindowProps, ILinkWindowState> {
    panel_el: HTMLDivElement = null;
    linkInputEl: HTMLInputElement = null;

    constructor(props: ILinkWindowProps) {
        super(props);
    }

    componentDidMount() {
        window.getSelection().selectAllChildren(this.panel_el);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
    }

    render() {
        let {
            link,
            onClose,
            className,
            t,
            tReady,
            i18n,
            ...restPanelProps
        } = this.props;

        return (
            <Panel
                className={clsx('link-window', className)}
                {...restPanelProps}
            >
                <PanelHeader className='link-window-header'>
                    <div className="header-text">
                        {t('Ссылка скопирована в буфер обмена')}
                    </div>
                    <CloseButton onClick={() => { onClose(); }} />
                </PanelHeader>
                <PanelBody className='link-window-body' ref={(el) => { this.panel_el = el; }}>
                    <OverlayFormInput
                        readOnly
                        value={this.props.link}
                        wrapperClassname='link-input'
                        variant='underlined'
                        ref={(el) => { this.linkInputEl = el; }}
                        onClick={(e) => {
                            e.currentTarget.setSelectionRange(0, 9999);
                        }}
                    />
                </PanelBody>
            </Panel>
        );
    }
}

export const LinkWindow = withTranslation()(LinkWindowComponent);
